import React, {Component} from 'react';
import './ChangePasswordComponent.less';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {InlineMessage} from '@homeaway/react-alerts';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {apiPost} from '../../util/api.client';
import {validatePasswordConstraint, pwdLengthOptions, validate} from '../../util/password.settings';
import edapWrapper from '@homeaway/edap-wrapper';

class ChangePasswordComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            confirmPassword: '',
            ticketId: this.props.ticketId,
            loggedIn: false,
            loading: false,
            passwordType: 'password',
            confirmPasswordType: 'password',
            pwdReqMet: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.checkStatus = this.checkStatus.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.showHide = this.showHide.bind(this);
        this.triggerSubmit = this.triggerSubmit.bind(this);
    }

    showHide(e) {
        e.preventDefault();
        e.stopPropagation();
        let control = event.target.id;
        const shouldHide = control === 'passwordType' ? this.state.passwordType === 'input' : this.state.confirmPasswordType === 'input';
        const action = shouldHide ? 'hide' : 'show';
        const eventaction = control === 'passwordType' ? `${action}Pwd.click` : `${action}ConfirmPwd.click`;
        edapWrapper().push({
            name: 'generic.click',
            data: {eventcategory: 'lex.auth', eventaction, actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.setState({
            [control]: shouldHide ? 'password' : 'input'
        });
    }

    handleSubmit(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleError(error) {
        edapWrapper().push({
            name: 'generic.event',
            data: {eventaction: 'passwordchange.failure', eventcategory: 'lex', eventlabel: 'ums', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.props.handleError(error);
        this.setState({confirmPassword: '', password: ''});
    }

    isValidPassword() {
        return !validate({p: this.state.password}, validatePasswordConstraint);
    }

    passwordsMatch() {
        if (this.state.confirmPassword === this.state.password) {
            return true;
        }
        return false;
    }

    validateFields() {
        if (this.state.password === '' || this.state.confirmPassword === '') {
            return false;
        }
        return true;
    }

    triggerSubmit(e) {
        e.preventDefault();
        this.props.enableLoading();
        setTimeout(() => {
            this.submitForm();
        }, 800);
    }

    submitForm() {
        if (!this.isValidPassword() || !this.passwordsMatch()) {
            this.props.disableLoading();
            return;
        }
        edapWrapper().push({
            name: 'generic.event',
            data: {eventaction: 'passwordchange.attempt', eventcategory: 'lex', eventlabel: 'ums', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        apiPost('/auth/aam/v3/password/change', {
            newPassword: this.state.password,
            confirmedPassword: this.state.confirmPassword,
            ticketId: this.state.ticketId
        }).then(this.checkStatus);
    }

    checkStatus(response) {
        switch (response.status) {
            case 200:
                this.changeSuccess();
                break;
            case 400: // passwords don't match or invalid or bad format shouldn't happen since we validate UI
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('lex.password.invalid'));
                break;
            case 401: // ticket id was invalid
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('lex.ticket.invalid'));
                break;
            case 417:
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('lex.password.previous'));
                break;
            case 422: // password length too long/short shouldn't happen since we validate UI
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('ums.validation.password.length', pwdLengthOptions, 'validation'));
                break;
            default:
                this.props.disableLoading();
                this.handleError(this.props.lingua.read('error.generic'));
                break;
        }
    }

    changeSuccess() {
        edapWrapper().push({
            name: 'generic.event',
            data: {
                eventaction: 'passwordChange.success',
                eventcategory: 'lex',
                eventlabel: 'ums',
                actionlocation: this.props.actionLocation
            },
            options: {'delayProcessing': true}
        });
        this.props.updatePage('success');
    }

    getPasswordContent() {
        let passwordFieldClasses = `form-group floating-label ${this.state.password === '' ? '' : 'not-empty'} has-feedback`;
        return (
            <div className={passwordFieldClasses}>
                <label>{this.props.lingua.read('lex.password.change.prompt')}</label>
                <input type={this.state.passwordType} className="form-control" aria-label={this.props.lingua.read('lex.password.change.prompt')}
                    name="password" onChange={this.handleChange} value={this.state.password} autoComplete = "new-password"
                />
                <span id="passwordType" className="PasswordShow" onClick={this.showHide}>
                            {(this.state.passwordType === 'input') ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')}
                </span>
                {this.state.password === '' && <InlineMessage id="pwdMessage" type="help" message={this.props.lingua.read('lex.password.requirements', pwdLengthOptions)}/>}
                {this.state.password !== '' && <InlineMessage id="pwdMessage" type={this.isValidPassword() ? 'success' : 'danger'} message={this.props.lingua.read('lex.password.requirements', pwdLengthOptions)}/>}
            </div>
        );
    }

    getConfirmPwdContent() {
        let confirmPasswordFieldClasses = `form-group floating-label ${this.state.confirmPassword === '' ? '' : 'not-empty'} has-feedback`;
        return (
            <div className={confirmPasswordFieldClasses}>
                <label>{this.props.lingua.read('lex.password.confirm')}</label>
                <input type={this.state.confirmPasswordType} className="form-control" aria-label={this.props.lingua.read('lex.password.confirm')}
                    name="confirmPassword" onChange={this.handleChange} value={this.state.confirmPassword} autoComplete = "confirm-password"
                />
                <span id="confirmPasswordType" className="PasswordShow" onClick={this.showHide}>
                            {(this.state.confirmPasswordType === 'input') ? this.props.lingua.read('lex.password.hide') : this.props.lingua.read('lex.password.show')}
                        </span>
                {this.state.confirmPassword !== '' && <InlineMessage id="confirmPwdMessage" type={this.passwordsMatch() ? 'success' : 'danger'}
                    message={this.props.lingua.read(`lex.password.change.confirm${this.passwordsMatch() ? '' : '.error'}`)}
                                                      />}
            </div>
        );
    }

    render() {
        let passwordContent = this.getPasswordContent();
        let confirmPwdContent = this.getConfirmPwdContent();
        return (
            <div className="ChangePasswordComponent">
                <form onSubmit={this.triggerSubmit} noValidate>
                    {passwordContent}
                    {confirmPwdContent}
                    <div className="Save_button text-center">
                        <ButtonPrimary type="submit" label={this.props.lingua.read('lex.password.change.button')} disabled={!this.validateFields()}>
                            <LoadingOverlay loading={this.props.isWaiting}/>
                        </ButtonPrimary>
                    </div>
                </form>
            </div>
        );
    }
}

export default ChangePasswordComponent;
